module.exports = __webpack_public_path__ + "img/704-434902.png";